($ => {

    "use strict";

    function speakerFromAddButton(button) {
        const root = button.closest(".card-palestrante-site, .card-palestrante-portrait, .page-palestrante-site")
            || document;
        const name = (
            root.querySelector("h3")?.textContent
            || root.querySelector("h1")?.textContent
            || button.getAttribute("aria-label")
            || ""
        ).replace(/\s+/g, " ").trim();
        return {
            id: parseInt(button.getAttribute("data-palestrante-id"), 10) || 0,
            name,
            img: root.querySelector("img")?.currentSrc || root.querySelector("img")?.src || "",
            url: root.querySelector("a[href*='/palestrantes/']")?.getAttribute("href") || "#",
            specialty: (
                root.querySelector(".card-palestrante-site-overlay-specialty, .card-palestrante-site-specialty")
                    ?.textContent || ""
            ).replace(/\s+/g, " ").trim(),
        };
    }

    $(document).ready(() => {
        $(document).on("click", ".card-palestrante-site [data-add-orcamento], .card-palestrante-portrait [data-add-orcamento], .page-palestrante-site [data-add-orcamento]", async function(event) {
            event.preventDefault();
            event.stopPropagation();
            const button = $(this);
            if (button.prop("disabled") || button.hasClass("is-in-cesta")) {
                return;
            }
            const palestranteId = parseInt(button.attr("data-palestrante-id"), 10) || 0;
            if (!palestranteId) {
                return;
            }
            const silent = button.is("[data-cesta-no-open]")
                || Boolean(this.closest(".page-palestrante-site"));
            const pickerOpen = Boolean(document.getElementById("cesta-pick-dialog")?.open);
            try {
                button.prop("disabled", true).attr("aria-busy", "true").addClass("is-loading");
                if (!silent && !pickerOpen) {
                    document.dispatchEvent(new CustomEvent("site:cesta-open"));
                }
                document.dispatchEvent(new CustomEvent("site:cesta-optimistic-add", {
                    detail: speakerFromAddButton(this),
                }));
                const responseHTML = await ServerActions.getGlobal("add_palestrante_orcamento", {
                    pid: palestranteId,
                    fragment: "cesta",
                });
                Events.dispatch(ServerEvents.ADD_PALESTRANTE_ORCAMENTO, [responseHTML, { silent }]);
            } catch (error) {
                UIMessages.error("Erro ao adicionar palestrante na cesta.", "#cesta-orcamento-site");
                button.prop("disabled", false);
            } finally {
                button.removeAttr("aria-busy").removeClass("is-loading");
            }
        });
    });

})(jQuery);
